/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const cashflowService = {
  getList: (params: any) => request.get('/report/cashflow', { params })
};

export default cashflowService;
